/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Reload_Remote_DraftInputs */

const vi_einvoice_reload_remote_draft = /** @type {(inputs: Einvoice_Reload_Remote_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lấy lại nháp từ MISA`)
};

/**

* @param {Einvoice_Reload_Remote_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_reload_remote_draft = /** @type {((inputs?: Einvoice_Reload_Remote_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Reload_Remote_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_reload_remote_draft(inputs)
});